module.exports = __webpack_public_path__ + "static/LaunchDarkly_Horizontal_Navy-95d6e29681b0e51f978b9311ca6c05e6.png";